<template>
    <div class="dashboard">
        <loading ref="vLoadScreen"/>
        <header-navigation/>
        <div class="container">
            <oops ref="vOops"/>
            <error ref="vError"/>
            <vessel-header ref="vHeader"/>
            <div class="vesselDashContent">
                <vessel-voyage ref="vVoyage" />
                <vessel-latest-pos ref="vLatePos"/>
                <vessel-info ref="vInfo"/>
                <vessel-platforms ref="vPlatform"/>
                <div class="dashFlexContent">
                    <vessel-chart-platforms ref="vChartPlatform"/>
                    <vessel-chart-companies ref="vChartCompany"/>
                </div>
                <vessel-chart-utilization ref="vChartUtil"/>
                <vessel-port-calls ref="vPortCalls" />
                <vessel-leases ref="vLeases"/>
                <vessel-histogram-platforms ref="vHistPlatform"/>
                <vessel-histogram-leases ref="vHistLease"/>
                <vessel-histogram-port ref="vHistPort"/>
                <vessel-similar-supply ref="vSimilar"/>
            </div>
        </div>
        <bottom-credits />
    </div>
</template>

<script>
import axios from 'axios';
import VesselHeader from '../components/dashboard/VesselHeader.vue';
import VesselInfo from '../components/dashboard/VesselInfo.vue';
import VesselLatestPos from '../components/dashboard/VesselLatestPos.vue';
import VesselPlatforms from '../components/dashboard/VesselPlatforms.vue';
import VesselPortCalls from '../components/dashboard/VesselPortCalls.vue';
import VesselVoyage from '../components/dashboard/VesselVoyage.vue';
import VesselChartPlatforms from '../components/dashboard/VesselChartPlatforms.vue';
import VesselChartCompanies from '../components/dashboard/VesselChartCompanies.vue';
import VesselChartUtilization from '../components/dashboard/VesselChartUtilization.vue';
import VesselSimilarSupply from '../components/dashboard/VesselSimilarSupply.vue';
import VesselLeases from '../components/dashboard/VesselLeases.vue';
import VesselHistogramPlatforms from '../components/dashboard/VesselHistogramPlatforms.vue';
import VesselHistogramLeases from '../components/dashboard/VesselHistogramLeases.vue';
import VesselHistogramPort from '../components/dashboard/VesselHistogramPort.vue';
import Loading from '../components/Loading.vue';
import Oops from '../components/Oops.vue';
import Error from '../components/Error.vue';
import BottomCredits from '../components/BottomCredits.vue';
import HeaderNavigation from '../components/HeaderNavigation.vue';
import { matchFlag } from '../helpers/FillFlag.js';
import { findTimeOffset } from '../helpers/Formatting.js';

export default {
    name: "Vessels",
    components: {
        VesselHeader,
        VesselInfo,
        VesselLatestPos,
        VesselPlatforms,
        VesselPortCalls,
        VesselVoyage,
        VesselChartPlatforms,
        VesselChartCompanies,
        VesselChartUtilization,
        VesselSimilarSupply,
        VesselLeases,
        VesselHistogramPlatforms,
        VesselHistogramLeases,
        VesselHistogramPort,
        Loading,
        Oops,
        Error,
        BottomCredits,
        HeaderNavigation
    },
    data: () => ({
        loadStatus: 0
    }),
    mounted() {
        var globv = this;
        globv.$refs.vLoadScreen.startLoading();
        globv.retrieveVesselData();
    },
    methods: {
        retrieveVesselData: function() {
            var globv = this;
            let mmsi = globv.$route.params.mmsi;
            axios.get('/api/vessels/' + mmsi).then((response) => {
                // console.log(response);
                if (!(response['data']['error'])) {
                    let vessel = response['data'];
                    let name = vessel['vesselInfo']['general']['name'];
                    
                    let flag = vessel['vesselInfo']['general']['flag'];
                    
                    if (flag) {
                        let [tempFlag, formatFlag] = matchFlag(flag);

                        if (formatFlag) {
                            flag = tempFlag;
                            vessel['vesselInfo']['general']['flag'] = formatFlag;
                        }
                        else {
                            console.log("Didn't find flag match:", flag);
                            flag = null;
                        }
                    }

                    globv.$refs.vHeader.updateInfo({
                        name: name,
                        flag: flag,
                        type: vessel['vesselInfo']['general']['vesselType']['generic'],
                        mmsi: vessel['vesselInfo']['general']['mmsi'],
                        imo:  vessel['vesselInfo']['general']['imo']
                    });
                    globv.$refs.vVoyage.updateInfo(vessel['voyage'], vessel['vesselInfo']['general']['aisVersion'], name);
                    globv.$refs.vInfo.updateInfo(vessel['vesselInfo']);
                    globv.$refs.vLatePos.updateInfo(vessel['latestPos']);
                    globv.$refs.vLatePos.passInName(name);
                    globv.$refs.vPlatform.updateInfo(vessel['events']);
                    globv.$refs.vPortCalls.updateInfo(vessel['events']);
                    globv.$refs.vLeases.updateInfo(vessel['events']);
                    globv.$refs.vSimilar.findSimilar(vessel['vesselInfo']['dimensions']['deckSize'], vessel['vesselInfo']['general']['topSpeed']);
                }

                globv.loadStatus += 1;
            })
            .catch(error => {
                globv.reset();
                globv.handleError(error);
            });

            axios.get('/api/vessels/stats/' + mmsi, {
                params: {
                    timeOffset: findTimeOffset()
                }
            }).then((response) => {
                if (globv.loadStatus >= 2) {
                    return;
                }

                // console.log(response);
                if (!(response['data']['error'])) {
                    let stats = response['data'];

                    globv.$refs.vChartPlatform.createChart(stats['timeSpentPerPlatform']);
                    globv.$refs.vChartCompany.createChart(stats['companiesServed']);
                    globv.$refs.vChartUtil.createChart(stats['utilization']);
                    globv.$refs.vHistPlatform.createChart(stats['histogram']['platforms']);
                    globv.$refs.vHistLease.createChart(stats['histogram']['leases']);
                    globv.$refs.vHistPort.createChart(stats['histogram']['ports']);
                }
                
                globv.loadStatus += 1;
            })
            .catch(error => {
                //FIXME this should use error handler and not break if stats dont load
                //globv.handleError(error);
                console.log(error);
                globv.loadStatus += 1;
            });
        },
        handleError: function(error) {
            var globv = this;
            // console.log(error, error.response);
            if (globv.loadStatus < 2) {
                globv.loadStatus = 2;
                error = error.response.data;
                if (error['error'] && error['error']['status'] < 500) {
                    if (error['error']['status'] == 404)
                        globv.$refs.vError.showError({
                            status: 404, 
                            title: "Not Found", 
                            message: error['error']['message']
                        });
                    else
                        globv.$refs.vError.showError({
                            status: error['error']['status'],
                            message: error['error']['message']
                        });
                }
                else
                    globv.$refs.vOops.showOops();
            }
        },
        reset: function() {
            var globv = this;

            globv.$refs.vHeader.reset();
            globv.$refs.vVoyage.reset();
            globv.$refs.vInfo.reset();
            globv.$refs.vLatePos.reset();
            globv.$refs.vPlatform.reset();
            globv.$refs.vSimilar.reset();
            globv.$refs.vChartPlatform.reset();
            globv.$refs.vChartCompany.reset();
            globv.$refs.vChartUtil.reset();
            globv.$refs.vHistPlatform.reset();
            globv.$refs.vHistLease.reset();
            globv.$refs.vHistPort.reset();
        }
    },
    watch: {
        '$route.params.mmsi': function() {
            var globv = this;
            globv.loadStatus = 0;
            globv.$refs.vLoadScreen.startLoading();
            globv.reset();
           
            globv.retrieveVesselData();
        },
        loadStatus: function() {
            var globv = this;
            
            if (globv.loadStatus == 2) {
                setTimeout(globv.$refs.vLoadScreen.finishLoading, 300);
                globv.loadStatus = 3;
            }
        }
    }
}
</script>

<style lang="scss">
.vesselDashContent {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: center;
    width: 100%;
    flex: 1 0 auto;

    > .card {
        max-width: 1140px;
        width: 80%;
    }

    .dashFlexContent {
        width: 80%;

        .chart {
            width: 400px;
        }
    }
}

@media (max-width: 1200px) {
    .vesselDashContent {
        width: 98vw;

        .card {
            margin: 20px 10px;
            width: 98%;

            .note {
                align-items: flex-start;
            }
        }

        .dashFlexContent {
            width: 100%;

            .voyageWidth {
                width: 50%;
            }
        }
    }
}

@media (max-width: 932px) {
    .vesselDashContent {
        .chart {
            width: 90vw;
        }
        
        .card {
            width: 100%;
            margin: 20px 0;
        }

        .dashFlexContent {
            flex-direction: column;
            align-items: center;
            width: 100%;

            .chart {
                width: 90vw;
            }

            .voyageWidth {
                width: 100%;
            }
        }
    }
}

@media (max-width: 930px) {
    .latestPosLayout {
        display: flex;
        flex-direction: column;
    }
}

@media (max-width: 660px) {
    .vesselDashContent {
        padding: 0;
        width: 100%;
    }
}

@media (max-width: 540px) {
    .vesselDashContent {
        width: fit-content;

        .cardContent {
            padding: 0 10px 10px;
        }

        p {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }

        .histogramList {
            p {
                align-items: center;
            }
        }
    }
}

.eventsTable {
    border-collapse: collapse;
    text-align: center;
    width: 100%;
    justify-self: center;

    thead tr {
        border-bottom: lightgrey 1px solid;
        border-bottom-color: var(--secondaryBorderColor);
    }

    th, td {
        padding: 10px 18px;
    }

    tr:nth-child(even) {
        background-color: #f2f2f2;
        background-color: var(--tableMediumColor);
    }
}

@media (max-width: 550px) {
    .eventsTable { 
        thead {
            border: none;
            height: 1px;
            width: 1px;
            margin: -1px;
            overflow: hidden;
            padding: 0;
            position: absolute;
        }

        tr {
            display: grid;
            margin-bottom: 10px;
            border: 1px solid lightgray;
            border-color: var(--secondaryBorderColor);

            &:nth-child(even) {
                background-color: #DEDEE3;
                background-color: var(--tableDarkColor);
            }
        }

        td {
            border-bottom: 1px dotted lightgray;
            border-bottom-color: var(--secondaryBorderColor);
            display: grid;
            grid-template-columns: 40% 1fr;
            column-gap: 10px;
            font-weight: bold;
            text-align: start;

            &:last-child {
                border-bottom: none;
            }

            &::before {
                content: attr(data-label);
                float: left;
                font-weight: normal;
                text-align: left;
            }
        }
    }
}

@media (max-width: 345px) {
    .eventsTable td {
        grid-template-columns: 1fr;
    }
}

</style>